// extracted by mini-css-extract-plugin
export var copyableItem = "_4e-0";
export var underlined = "_4e-1";